import type { FC } from 'react';

import { Head } from '@eneco/next';
import { useContent } from '@sitecore/common';
import { StructuredDataSchemaRendering } from '@sitecore/types/manual/StructuredDataSchema';

const StructuredDataSchema: FC<StructuredDataSchemaRendering> = () => {
  const { fields } = useContent<StructuredDataSchemaRendering>();

  if (!fields?.schemas?.length) return null;

  return (
    <Head>
      <script type="application/ld+json">{JSON.stringify(fields.schemas)}</script>
    </Head>
  );
};

export { StructuredDataSchema };
export default StructuredDataSchema;
